// Şifre ile yeniden doğrulama penceresi (her geçiş işleminden önce)
import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

export const ReauthDialog = ({ action, onClose, onConfirm }) => {
  const [pw, setPw] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { await onConfirm(pw); setPw(''); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!action} onOpenChange={(o) => { if (!o) { setPw(''); onClose(); } }}>
      <DialogContent data-testid="mig-reauth-dialog">
        <DialogHeader>
          <DialogTitle>{action?.title}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">{action?.description}</DialogDescription>
        </DialogHeader>
        <Input type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="Platform Sahibi şifresi" autoFocus
          onKeyDown={e => e.key === 'Enter' && pw && submit()} data-testid="mig-reauth-password" />
        <DialogFooter>
          <Button variant="outline" onClick={() => { setPw(''); onClose(); }} data-testid="mig-reauth-cancel">Vazgeç</Button>
          <Button onClick={submit} disabled={!pw || busy} className={action?.danger ? 'bg-rose-600 hover:bg-rose-700' : ''} data-testid="mig-reauth-confirm">{action?.confirmLabel || 'Onayla'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
